import { ValueLabelOption } from 'pages/QuoteView/LoadBuilding/McleodSectionForms/types';

export const transportTypes: ValueLabelOption[] = [
  { value: 'V', label: 'VAN' },
  { value: 'VA', label: 'AIR-RIDE VAN' },
  { value: 'VC', label: 'CURTAIN VAN' },
  { value: 'VLG', label: 'VAN LIFTGATE' },
  { value: 'VP', label: 'VAN PARTIAL' },
  { value: 'VR', label: 'VAN OR REEFER' },
  { value: 'R', label: 'REEFER' },
  { value: 'F', label: 'FLATBED' },
  { value: 'FA', label: 'AIR-RIDE FLATBED' },
  { value: 'FOD', label: 'FLATBED OD' },
  { value: 'FOW', label: 'FLATBED OW' },
  { value: 'FSD', label: 'FLATBED - STEPDECK' },
  { value: 'FSDC', label: 'FLATBED -STEPDECK - CON.' },
  { value: 'HS', label: 'HOTSHOT' },
  { value: 'HSDT', label: 'HS PULLOUT OR DOVETAIL' },
  { value: 'HSOD', label: 'HOTSHOT OD' },
  { value: 'HSWR', label: 'HOTSHOT WRAMPS' },
  { value: 'HSWW', label: 'HOTSHOT W WINCH' },
  { value: 'STR', label: 'STRAIGHT TRUCK' },
  { value: 'SPRI', label: 'SPRINTER' },
  { value: 'STEP', label: 'STEPDECK' },
  { value: 'SDC', label: 'STEPDECK CONESTOGA' },
  { value: 'SDOD', label: 'STEPDECK OD' },
  { value: 'SDR', label: 'STEPDECK WRAMPS' },
  { value: 'STRD', label: 'STRETCH - STEPDECK' },
  { value: 'STRE', label: 'STRETCH - RGN' },
  { value: 'STRF', label: 'STRETCH - FLATBED' },
  { value: 'LB', label: 'LOWBOY' },
  { value: 'RGN', label: 'RGN' },
  { value: 'RGNW', label: 'RGN W WINCH' },
  { value: 'RGOD', label: 'RGN OD' },
  { value: 'RGOW', label: 'RGN OW' },
  { value: 'DD', label: 'DOUBLE DROP' },
  { value: 'LAND', label: 'LANDOLL' },
  { value: 'CON', label: 'CONESTOGA' },
  { value: 'PO', label: 'POWER ONLY' },
  { value: 'POOD', label: 'POWER ONLY OD' },
  { value: 'POOW', label: 'POWER ONLY OW' },
  { value: 'PH', label: 'POWER ONLY PINTLE HITCH' },
  { value: 'HOP', label: 'HOPPER' },
  { value: 'DRVR', label: 'DRIVE AWAY' },
  { value: 'WRE', label: 'WRECKER' },
  { value: 'ODS', label: 'OPEN DECK + SERVICE' },
  { value: 'PARF', label: 'PARTIAL - OPEN DECK' },
  { value: 'TORD', label: 'TRUCK ORDERED NOT USED' },
];

// Aljex rate type labels used in the Builder form and TMS mapping.
export const ALJEX_RATE_TYPE_LABELS = [
  'Flat Rate',
  'All In',
  'Auto Rate',
  'CWT',
  'Ton',
  'Pieces',
  'Mileage',
  'Hourly',
  'Gainshare',
  'Percent',
] as const;

// Customer rate types (excludes carrier-only Percent).
export const ALJEX_CUSTOMER_RATE_TYPE_LABELS = ALJEX_RATE_TYPE_LABELS.filter(
  (label) => label !== 'Percent'
);

// Carrier rate types (excludes customer-only Gainshare).
export const ALJEX_CARRIER_RATE_TYPE_LABELS = ALJEX_RATE_TYPE_LABELS.filter(
  (label) => label !== 'Gainshare'
);

export const ALJEX_RATE_TYPE_CODE_TO_LABEL: Record<string, string> = {
  F: 'Flat Rate',
  I: 'All In',
  A: 'Auto Rate',
  C: 'CWT',
  T: 'Ton',
  P: 'Pieces',
  M: 'Mileage',
  H: 'Hourly',
  G: 'Gainshare',
  '%': 'Percent',
};

export const ALJEX_RATE_TYPE_LABEL_TO_CODE: Record<string, string> =
  Object.fromEntries(
    Object.entries(ALJEX_RATE_TYPE_CODE_TO_LABEL).map(([code, label]) => [
      label,
      code,
    ])
  );
